import { z } from "zod";

export const OVERLEVERING_CHECKLIST_TYPES = {
  OVERLEVERING: "startup_checklist_overlevering",
} as const;

export const ZOverleveringChecklistType = z.enum([OVERLEVERING_CHECKLIST_TYPES.OVERLEVERING]);

export const ZOverleveringChecklistAnswer = z.enum(["JA", "NEI", "IR"]);

export const ZOverleveringChecklistMeta = z.object({
  title: z.string(),
  oppdragsnummer: z.string(),
  oppdragsnavn: z.string(),
});

export const ZOverleveringChecklistSectionRow = z.object({
  nr: z.string(),
  text: z.string(),
  kind: z.literal("SECTION"),
});

export const ZOverleveringChecklistQuestionRow = z.object({
  nr: z.string(),
  text: z.string(),
  kind: z.literal("QUESTION"),
  answer: ZOverleveringChecklistAnswer.nullable(),
  comment: z.string(),
});

export const ZOverleveringChecklistRow = z.discriminatedUnion("kind", [
  ZOverleveringChecklistSectionRow,
  ZOverleveringChecklistQuestionRow,
]);

export const ZOverleveringChecklistReport = z.object({
  overleveringChecklistType: ZOverleveringChecklistType,
  overleveringChecklistMeta: ZOverleveringChecklistMeta,
  rows: z.array(ZOverleveringChecklistRow),
});

export type IOverleveringChecklistAnswer = z.infer<typeof ZOverleveringChecklistAnswer>;
export type IOverleveringChecklistMeta = z.infer<typeof ZOverleveringChecklistMeta>;
export type IOverleveringChecklistSectionRow = z.infer<typeof ZOverleveringChecklistSectionRow>;
export type IOverleveringChecklistQuestionRow = z.infer<typeof ZOverleveringChecklistQuestionRow>;
export type IOverleveringChecklistRow = z.infer<typeof ZOverleveringChecklistRow>;
export type IOverleveringChecklistReport = z.infer<typeof ZOverleveringChecklistReport>;
export type IOverleveringChecklistType = z.infer<typeof ZOverleveringChecklistType>;

export type OverleveringChecklistRowDef =
  | {
      nr: string;
      text: string;
      kind: "SECTION";
    }
  | {
      nr: string;
      text: string;
      kind: "QUESTION";
    };
